// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.roles_dashboard__4yfgl {
  width: calc(100% - 200px);
  position: relative;
  left: 200px;
  padding: 20px;
}

.roles_cont2__F1WGU {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.roles_bodythemelight__sS\\+-A {
  background-color: #f3f6f9;
}

.roles_bodythemedark__\\+pgu- {
  background-color: #151521;
}

.roles_headerthemelight__hiV4V {
  background-color: #fff;
}

.roles_headerthemedark__Mj8Nq {
  background-color: #151521;
}

.roles_menuthemelight__zWxpo {
  background-color: #fff;
}

.roles_menuthemedark__\\+RiU\\+ {
  background-color: #151521;
}

.roles_menulinklight__PK4wh {
  color: #60677e !important;
}

.roles_menulinklightSelected__0oUik {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.roles_menulinkdarkSelected__DWw4c {
  color: #fff !important;
  border-radius: 10px;
}

.roles_menulinkdark__UHzLp {
  color: #60677e !important;
}

.roles_menulinklight__PK4wh:hover {
  color: #1d1d1d !important;
}

.roles_menulinkdark__UHzLp:hover {
  color: #fff !important;
}

.roles_headinglight__sFFb2 {
  color: #60677e;
}

.roles_headingdark__HqAwD {
  color: #60677e;
}

.roles_searchboxlight__ITJcb {
  background-color: #fff;
  border: none;
}

.roles_searchboxdark__FXbvW {
  background-color: #1e1e2d;
  color: #60677e;
}

.roles_searchboxdark__FXbvW::placeholder {
  color: #60677e;
}

.roles_tableheadlight__xTDAq {
  background-color: #e9eaf0;
}

.roles_tableheaddark__J0LSu {
  background-color: #1e1e2d;
  color: #60677e;
}

.roles_tablebodylight__0Ou95 {
  background-color: #fff;
}
.roles_tablebodylight__0Ou95:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.roles_tablebodydark__Ngbad {
  background-color: #1e1e2d;
  color: #60677e;
}
.roles_tablebodydark__Ngbad:hover {
  background-color: #252530;
  cursor: pointer;
}

.roles_paginationlight__yamMe {
  color: #60677e !important;
  font-size: 13px !important;
}

.roles_paginationdark__TjEXJ {
  color: #60677e !important;
  font-size: 13px !important;
}

.roles_formthemelight__PmCyW {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.roles_formthemedark__Xh2Nd {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.roles_formthemedark__Xh2Nd ::placeholder {
  color: #60677e;
}

.roles_viewformlight__IJDiM {
  background-color: #f3f6f9;
}

.roles_viewformdark__GZro8 {
  background-color: #151521;
}

.roles_permissionboxlight__ftJGG {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.roles_permissionboxdark__DI9iz {
  background-color: #151521;
  border: none;
}

.roles_errormsgclr__V4ArJ {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.roles_graphclrlight__qRcLf {
  background-color: #fff;
}

.roles_graphclrdark__n\\+HC8 {
  background-color: #1e1e2d;
}

#roles_card1bglight__y25Vd {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#roles_card1bgdark__AmVLQ {
  background: #392f28;
}

#roles_card2bglight__bb8Lp {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#roles_card2bgdark__R9941 {
  background: #1c3238;
}

#roles_card3bglight__Wiala {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#roles_card3bgdark__Nisqf {
  background: #3a2434;
}

#roles_card4bglight__IOSx6 {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#roles_card4bgdark__HIH4M {
  background: #2f264f;
}

.roles_actionbtnlight__023vz {
  color: rgba(70, 71, 91, 0.8705882353);
}

.roles_actionbtndark__4YaoZ {
  color: #60677e;
}

.roles_profiledropdownlight__zL-Fd {
  background-color: #fff;
}

.roles_profiledropdowndark__vH2QF {
  background-color: #151521;
}

@media only screen and (max-width: 600px) {
  .roles_cont2__F1WGU {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
.roles_indexdiv__U57Ph #roles_addheading__zhrfZ {
  font-size: 18px;
  font-family: "SFUIDisplay-Medium";
  margin-bottom: 20px;
}
.roles_indexdiv__U57Ph .roles_exportsection__FKCTm {
  float: right;
  width: 100%;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  #roles_dashboardcont2__pgQDy {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/index.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADiEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;AClDnB;;ADqEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC3CnB;;ADuEA;EACE,yBAtDgB;ACdlB;;ADwEA;EACE,yBA3DgB;ACVlB;;ADuEA;EACE,yBA7De;ACPjB;;ADwEA;EACE,sBAhEY;ACLd;;ADwEA;EACE,yBAtEe;ACCjB;;ADyEA;EACE,sBAzEY;ACGd;;ADwEA;EACE,yBA9Ee;ACSjB;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EAEE,yBAAA;EACA,mBAAA;ACvEF;;ADyEA;EAEE,sBAAA;EACA,mBAAA;ACvEF;;AD0EA;EACE,yBAAA;ACvEF;;AD0EA;EAEE,yBAAA;ACxEF;;AD0EA;EAEE,sBAAA;ACxEF;;AD4EA;EACE,cA5Ge;ACmCjB;;AD4EA;EACE,cAhHe;ACuCjB;;AD6EA;EACE,sBAvHY;EAwHZ,YAAA;AC1EF;;AD6EA;EACE,yBAvHkB;EAwHlB,cA3He;ACiDjB;;AD4EA;EACE,cA9He;ACqDjB;;AD6EA;EACE,yBA1HiB;ACgDnB;;AD4EA;EACE,yBAnIkB;EAoIlB,cAvIe;AC8DjB;;AD4EA;EACE,sBA7IY;ACoEd;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD4EA;EACE,yBAhJkB;EAiJlB,cApJe;AC2EjB;AD2EE;EACE,yBAAA;EACA,eAAA;ACzEJ;;AD8EA;EACE,yBAAA;EACA,0BAAA;AC3EF;;AD6EA;EACE,yBAAA;EACA,0BAAA;AC1EF;;AD8EA;EACE,sBA1KY;EA2KZ,yBAAA;EACA,qDAAA;AC3EF;;AD6EA;EACE,yBA1KkB;EA2KlB,yBAAA;EACA,eAAA;AC1EF;AD4EE;EACE,cAlLa;ACwGjB;;ADgFA;EACE,yBA9LgB;ACiHlB;;AD+EA;EACE,yBAhMe;ACoHjB;;AD+EA;EACE,yBAAA;EACA,yBAAA;AC5EF;;AD8EA;EACE,yBAAA;EACA,YAAA;AC3EF;;AD8EA;EACE,UAAA;EACA,eAAA;EACA,iCA9Le;EA+Lf,eAAA;AC3EF;;AD+EA;EACE,sBAnNY;ACuId;;AD+EA;EACE,yBAlNkB;ACsIpB;;ADgFA;EACE,mFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADgFA;EACE,kFAAA;AC7EF;;ADgFA;EACE,mBAAA;AC7EF;;ADkFA;EACE,qCAAA;AC/EF;;ADkFA;EACE,cAhQe;ACiLjB;;ADoFA;EACE,sBAAA;ACjFF;;ADoFA;EACE,yBAAA;ACjFF;;ADoFA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClFF;AACF;AA/PI;EACI,eAAA;EACA,iCDuEQ;ECtER,mBAAA;AAiQR;AA/PI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AAiQR;;AA1PA;EACI;IACI,wBDoEI;ICnEJ,UDoEG;ICnEH,kBAAA;IACA,aD6DW;ECgMjB;AACF","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 200px);\n$dashboardposition: absolute;\n$dashboardleft: 200px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n.menulinklight {\n  color: $lightthemetext !important;\n}\n\n.menulinklightSelected {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 600px) {\n\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n\n.indexdiv{\n\n    #addheading{\n        font-size: 18px;\n        font-family: $sffont-medium;\n        margin-bottom: 20px;\n    }\n    .exportsection{\n        float: right;\n        width: 100%;\n        margin-bottom: 20px;\n    }\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `roles_dashboard__4yfgl`,
	"cont2": `roles_cont2__F1WGU`,
	"bodythemelight": `roles_bodythemelight__sS+-A`,
	"bodythemedark": `roles_bodythemedark__+pgu-`,
	"headerthemelight": `roles_headerthemelight__hiV4V`,
	"headerthemedark": `roles_headerthemedark__Mj8Nq`,
	"menuthemelight": `roles_menuthemelight__zWxpo`,
	"menuthemedark": `roles_menuthemedark__+RiU+`,
	"menulinklight": `roles_menulinklight__PK4wh`,
	"menulinklightSelected": `roles_menulinklightSelected__0oUik`,
	"menulinkdarkSelected": `roles_menulinkdarkSelected__DWw4c`,
	"menulinkdark": `roles_menulinkdark__UHzLp`,
	"headinglight": `roles_headinglight__sFFb2`,
	"headingdark": `roles_headingdark__HqAwD`,
	"searchboxlight": `roles_searchboxlight__ITJcb`,
	"searchboxdark": `roles_searchboxdark__FXbvW`,
	"tableheadlight": `roles_tableheadlight__xTDAq`,
	"tableheaddark": `roles_tableheaddark__J0LSu`,
	"tablebodylight": `roles_tablebodylight__0Ou95`,
	"tablebodydark": `roles_tablebodydark__Ngbad`,
	"paginationlight": `roles_paginationlight__yamMe`,
	"paginationdark": `roles_paginationdark__TjEXJ`,
	"formthemelight": `roles_formthemelight__PmCyW`,
	"formthemedark": `roles_formthemedark__Xh2Nd`,
	"viewformlight": `roles_viewformlight__IJDiM`,
	"viewformdark": `roles_viewformdark__GZro8`,
	"permissionboxlight": `roles_permissionboxlight__ftJGG`,
	"permissionboxdark": `roles_permissionboxdark__DI9iz`,
	"errormsgclr": `roles_errormsgclr__V4ArJ`,
	"graphclrlight": `roles_graphclrlight__qRcLf`,
	"graphclrdark": `roles_graphclrdark__n+HC8`,
	"card1bglight": `roles_card1bglight__y25Vd`,
	"card1bgdark": `roles_card1bgdark__AmVLQ`,
	"card2bglight": `roles_card2bglight__bb8Lp`,
	"card2bgdark": `roles_card2bgdark__R9941`,
	"card3bglight": `roles_card3bglight__Wiala`,
	"card3bgdark": `roles_card3bgdark__Nisqf`,
	"card4bglight": `roles_card4bglight__IOSx6`,
	"card4bgdark": `roles_card4bgdark__HIH4M`,
	"actionbtnlight": `roles_actionbtnlight__023vz`,
	"actionbtndark": `roles_actionbtndark__4YaoZ`,
	"profiledropdownlight": `roles_profiledropdownlight__zL-Fd`,
	"profiledropdowndark": `roles_profiledropdowndark__vH2QF`,
	"indexdiv": `roles_indexdiv__U57Ph`,
	"addheading": `roles_addheading__zhrfZ`,
	"exportsection": `roles_exportsection__FKCTm`,
	"dashboardcont2": `roles_dashboardcont2__pgQDy`
};
export default ___CSS_LOADER_EXPORT___;
